import React from 'react'
import * as bs4 from 'reactstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-dropdown-select';
import Navbar from '../Navbar'
import { ScaleLoader } from 'react-spinners';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
const { proxy } = require('../../ip_api.config')

class Acc_EditBom extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: '',
            isLoading: false,
            arr_item: [],
            arr_check: [],
            arr_show: [],
            arr_save: [],
        }
    }

    componentDidMount() {
        if (localStorage.getItem("ID_User") !== null) {
            this.setState({
                id: this.props.location.state.id_edit
            }, () => {
                this.getItem(this.state.db_name, 0)
            })
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    getItem = (db_name, _value) => {
        this.setState({ isLoading: true })

        let arr = []
        let url = proxy.server + '/acc/get_item'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                db_name: db_name,
                value: _value
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push({ value: val.NAMEALIAS, label: val.ITEMID })
                })
                this.setState({ option: arr, isLoading: false }, () => {
                    console.log('_value', _value)
                    if(_value === 0){
                        this.push_arrBomSave()
                    }else{
                        this.getBom_Preview()
                    }
                })
            })
    }

    push_arrBomSave = () => {
        this.setState({ isLoading: true })
        let arr = []
        let temp
        let url = proxy.server + '/acc/get_bomversion'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: this.state.id
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    let data = {
                        id: val.id,
                        db_name: val.db_name,
                        user: val.BOMVersion_ApproverPersonnelNumber,
                        bom_no: val.BOM_BOMId,
                        bom_description: val.BOM_Name,
                        type: val.BOM_BOMId.charAt(0),
                        item_group: val.BOM_ItemGroupId,
                        item_no: val.ItemId,
                        item_description: val.Name,
                    }

                    arr.push(data)
                })
                temp = this.state.arr_save.concat(arr)
                this.setState({ arr_save: temp, responseJson: arr }, () => { this.getBom_Preview() })
            })
    }

    getBom_Preview = () => {
        let arr = []

        this.state.responseJson.map(function (val, i) {
            arr.push(
                <tr>
                    <td><bs4.Col sm='12'>
                        <bs4.Input type="select" name="db_name" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                            <option value={val.db_name}>{val.db_name}</option>
                            <option value="DPL">DPL</option>
                            <option value="DFIX">DFIX</option>
                            <option value="DPT">DPT</option>
                        </bs4.Input>
                    </bs4.Col></td>
                    <td>{val.user}</td>
                    <td><bs4.Col sm='12'>
                        <bs4.Input type="text" name="bom_no" onChange={(e) => e.target.value.length > 20 ? alert('ห้ามกรอกเกิน 20 ตัวอักษร') : this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.bom_no} />
                    </bs4.Col></td>
                    <td><bs4.Col sm='12'>
                        <bs4.Input type="textarea" name="bom_description" onChange={(e) => e.target.value.length > 60 ? alert('ห้ามกรอกเกิน 60 ตัวอักษร') : this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.bom_description} />
                    </bs4.Col></td>
                    <td>{this.state.arr_save[i].type}</td>
                    <td>{this.state.arr_save[i].item_group}</td>
                    <td style={{ textAlign: 'center', width: 300 }}>
                        {/* <bs4.Input type="text" name="item_no" onChange={(e) => e.target.value.length > 20 ? alert('ห้ามกรอกเกิน 20 ตัวอักษร') : this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.item_no}/> */}
                        {/* <Select className="col-md-12"
                            onChange={(e) => this.handleChangeItem(i, 'item_no', e)}
                            options={this.state.option}
                            placeholder={val.item_no}
                        /> */}
                        <Autocomplete
                            id="combo-box-demo"
                            options={this.state.option}
                            getOptionLabel={(option) => option.label}
                            onChange={(event, values) => this.handleChangeItemAutocomplete(event, values, i)}
                            size={'small'}
                            renderInput={(params) => <TextField {...params} label={val.item_no} variant="outlined" onChange={(e) => this.getItem(val.db_name, e.target.value)} />}
                        />
                    </td>
                    <td>{val.item_description}</td>
                </tr>
            )
        }, this)
        this.setState({ previewbom: arr, isLoading: false })
    }

    handleChangeItem = (index, name, _value) => {
        let item_temp
        if (name === 'db_name') {
            this.state.arr_save[index].db_name = _value
        } else if (name === 'bom_no') {
            this.state.arr_save[index].bom_no = _value

            let type = _value.charAt(0)
            this.state.arr_save[index].type = type

            let item_group = type === 'G' ? 'FG' : type === 'H' ? 'HP' : type === 'S' ? 'SM' : type === 'P' ? 'PK' : type === 'S' ? 'SU' : '0'
            this.state.arr_save[index].item_group = item_group

        } else if (name === 'bom_description') {
            this.state.arr_save[index].bom_description = _value
        } else if (name === 'item_no') {
            let value = _value[0].value
            item_temp = value.split('$')
            this.state.arr_save[index].item_no = item_temp[0]
            this.state.arr_save[index].item_description = item_temp[1]
        }

        this.setState({
            arr_save: this.state.arr_save
        }, () => {
            console.log('arr_save', this.state.arr_save)
            this.getBom_Preview()
        })
    }

    handleChangeItemAutocomplete = (event, values, index) => {
        console.log('index', index)
        console.log('values', values)
        if (values === null || values === 'null') {
            let _item = ""
            this.state.arr_save[index].item_no = ""
            this.state.arr_save[index].item_description = ""

            this.setState({
                item_name: _item,
                arr_save: this.state.arr_save,
                selectedOption: ""
            }, () => {
                console.log('arr_save', this.state.arr_save)
                this.getBom_Preview()
            })
        } else {
            let _item = values.label
            this.state.arr_save[index].item_no = values.label
            this.state.arr_save[index].item_description = values.value

            this.setState({
                item_name: _item,
                arr_save: this.state.arr_save,
                selectedOption: values.label
            }, () => {
                console.log('arr_save', this.state.arr_save)
                this.getBom_Preview()
            })
        }
    }

    update_bom = () => {
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            this.setState({ isLoading: true })
            let url = proxy.server + '/acc/update_bomversion'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    id: this.state.id,
                    arr: this.state.arr_save
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false })
                        this.props.history.push({
                            pathname: '/Acc/PreviewBomVer'
                        })
                    } else {
                        this.setState({ isLoading: false })
                        alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                    }
                })
        }
    }

    render() {
        return <div>
            <Navbar nav={'Acc'} menu={'Acc_EditBom'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 20 }}>
                    <bs4.Label style={{ fontSize: 20, fontWeight: 500, marginRight: 20 }} >EDIT BOM VERSION</bs4.Label>
                    <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.update_bom()}>SAVE</bs4.Button>
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                <bs4.Table bordered hover style={{ fontSize: 15 }}>
                    <thead style={{ backgroundColor: '#8f8f8f', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            {/* <th></th> */}
                            <th>ฐานข้อมูล</th>
                            <th style={{ backgroundColor: '#8f8f8f', color: '#000' }}>รหัสพนักงาน</th>
                            <th>Bom No.</th>
                            <th>Bom Description</th>
                            <th style={{ backgroundColor: '#8f8f8f', color: '#000' }}>Type</th>
                            <th style={{ backgroundColor: '#8f8f8f', color: '#000' }}>Item Group</th>
                            <th>Item No.</th>
                            <th style={{ backgroundColor: '#8f8f8f', color: '#000' }}>Item Description</th>
                            {/* <th></th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.previewbom}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }
}

export default Acc_EditBom